import { FC, useContext, useEffect, useState } from "react"
import { Dialog } from 'primereact/dialog';

import { Button } from "primereact/button";
import { MdEdit, MdOutlineCancel } from "react-icons/md";
import { InputText } from "primereact/inputtext";
import { HiOutlinePencilSquare } from "react-icons/hi2";
import { TfiComment } from "react-icons/tfi";
import { Tooltip } from "primereact/tooltip";
import { Avatar } from "primereact/avatar";
import { UserContext } from "../../../../../Redux/UserContext";
import { BsPencil, BsTrash3 } from "react-icons/bs";
import { CiEdit } from "react-icons/ci";
import { catchResponse, generateUserColor } from "../../../../../utils/helperFunctions";
import { addComentario, deleteComentarioByID, editComentario, getComentariosByScenarioID } from "../../../../../services/scenario-service";
import { useParams } from "react-router-dom";
import moment from "moment";
import { error, success } from "../../../../../utils/notifications";
import { FiCommand } from "react-icons/fi";
import { IoSaveOutline } from "react-icons/io5";
import { AiOutlineClose } from "react-icons/ai";
import { InputNumber } from "primereact/inputnumber";




export const EditEntregasModalDialog:FC<any> = (props):JSX.Element => {

    const { dataTable, setData, comentarioEnEdicion, justComment, setComentarioEnEdicion, comentarioEditado, setComentarioEditado, dataTableMASTER, visible, selectedCell, selectedRow, setSelectedRow, handleClose, newComment, setNewComment, setChangesFlag, tabID, comm } = props 

    const [state] = useContext(UserContext);

    const {id}:any = useParams()

    const [renderedChat, setRenderedChat] = useState<any>(null);

    const [flag, setFlag] = useState<boolean>(false)

    const [loadingComentarios, setLoadingComentarios] = useState<boolean>(false)

    const [loadingUpdateComentarios, setLoadingUpdateComentarios] = useState<boolean>(false)

    const updateRenderedChat = () => {
        setRenderedChat(renderChat());
    };
    
    useEffect(() => {
        // Llama a updateRenderedChat cuando selectedCell o selectedRow cambien.
        updateRenderedChat();
    }, [selectedCell, selectedRow, flag]);

    const handleUpdateDataEntregas = () => {
        let original:any;
        let aux:any;
        switch(tabID) {
            
            case 1:
                original = dataTableMASTER.find((ori:any) => ori.id_proveedor === selectedRow.id_proveedor)?.[selectedCell][0]
                aux = dataTable
                
                let entregas_table = aux.map((a:any) => {
                    if(a.id_proveedor === selectedRow?.id_proveedor) {
                        
                        return {...selectedRow, edited: original != selectedRow?.[selectedCell][0]? true : false}
                    }
                    return a
                })
                entregas_table.filter((et:any) => 'edited' in et && et.edited).length > 0? setChangesFlag(false) : setChangesFlag(true)
                setData(entregas_table)
                handleClose()
                break;
            case 4:
                original = dataTableMASTER.find((ori:any) => ori.id_proveedor === selectedRow.id_proveedor)?.[selectedCell]
                aux = dataTable
                
                let camiones_table = aux.map((a:any) => {
                    if(a.id_proveedor === selectedRow?.id_proveedor) {
                        
                        return {...selectedRow, edited: original != selectedRow?.[selectedCell]? true : false}
                    }
                    return a
                })
                camiones_table.filter((et:any) => 'edited' in et && et.edited).length > 0? setChangesFlag(false) : setChangesFlag(true)
                setData(camiones_table)
                handleClose()
                break;
        }
        
        

    }

    const renderLabel = () => {
        let field_array = selectedCell?.split("_")
        
        if(field_array?.length > 1) field_array?.pop() 
        
        let header_title = field_array?.map((word:string,index:number) => {
            if(index === 0) {
                return word.charAt(0).toUpperCase() + word.slice(1)
            }
            return word
        }).join(' ')

        return header_title
    }

    const header = () => {
        return (
            <span>Ajuste de parámetros</span>
        )
    }

    const footer = () => {
        return (
            <div className="scenarios-footer">
                <Button disabled={loadingComentarios || loadingUpdateComentarios || comentarioEnEdicion !== undefined || justComment} severity={'success'} label="Actualizar" icon={<MdEdit style={{fontSize:20}} />}  onClick={handleUpdateDataEntregas} outlined  />
                <Button disabled={loadingComentarios || loadingUpdateComentarios || comentarioEnEdicion !== undefined} severity={'danger'} label="Cancelar" icon={<MdOutlineCancel style={{fontSize:20,marginRight:5}} />}  outlined onClick={handleClose} />
            </div>
        )
    }

    const handleChangeValue = (e:any) => {
        const { value } = e
    
        switch(tabID) {
            case 1:
                setSelectedRow({...selectedRow,[selectedCell]:[parseFloat(value),selectedRow[selectedCell][1],selectedRow[selectedCell][2]]})
                break;
            case 4:
                setSelectedRow({...selectedRow,[selectedCell]:parseFloat(value)})
                break;

        }
        
        
    }

    const handleDeleteComment = async(comentario:number) => {
        try {
            setLoadingComentarios(true)
            const res = await deleteComentarioByID(comentario)
            if(res.status === 200) {
                const {code,message} = res.data
                if(code === 200) {
                    handleUpdateComments(comentario,'delete')
                    success(message)
                } else {
                    setLoadingComentarios(false)
                    error(message)
                }
            }
        } catch(err:any) {
            setLoadingComentarios(false)
            catchResponse(err)
        }
    }

    const handleSaveUpdatedComment = async() => {
        try {
            setLoadingUpdateComentarios(true)
            
            let body:any = {
                id_comentario: comentarioEnEdicion,
                comentario_editado: comentarioEditado
            }

            const res = await editComentario(body)
            if(res.status === 200) {
                const {code,message} = res.data
                if(code === 200) {
                    handleUpdateComments(comentarioEnEdicion,'update')
                    success(message)
                    
                    
                } else {
                    error(message)
                    setLoadingUpdateComentarios(false)
                    
                }
            }
        } catch(err:any) {
            catchResponse(err)
            setLoadingUpdateComentarios(false)
            
        }
    }

    const handleCancelEditMode = () => {
        setComentarioEnEdicion(undefined)
        setFlag(!flag)
    }

    const handleEditComment = (comentario:any) => {
        setComentarioEditado(comentario.comentario)
        setComentarioEnEdicion(comentario.id_comentario)
        setFlag(!flag)
    }

    const handleChangeComentario = (e:any) => {
        setComentarioEditado(e.target.value)
        setFlag(!flag)
    }

    const renderChat = () => {
        let renderized_popup:any;

        if(selectedCell && selectedRow) {
            if(`comment_${selectedCell  }` in selectedRow) {
                renderized_popup = 
                <div style={{height:'100%'}}>
                    
                    <div style={{overflowY:'auto',height:'100%',paddingTop:'0.5rem',paddingRight:5}}>
                        {selectedRow[`comment_${selectedCell}`].map((comm:any) => {
                            return(
                                <p key={comm.id_comentario} style={{display:'flex',justifyContent:'space-between',alignItems:'center',minHeight:45}}>
                                    <span style={comentarioEnEdicion === comm.id_comentario? {display:'flex',justifyContent:'center',alignItems:'center',marginRight:5,width:'100%'} : {display:'flex',justifyContent:'center',alignItems:'center',marginRight:5}}><Avatar label={comm.avatar} style={{ backgroundColor: generateUserColor(comm.id_user), color: '#ffffff', marginRight:'5px', fontSize:'0.75rem', minWidth:32 }} shape="circle" />{comentarioEnEdicion === comm.id_comentario? <InputText disabled={loadingComentarios} value={comentarioEditado} onChange={handleChangeComentario}  placeholder="Escribe un nuevo comentario..." style={{width:'100%',fontSize:'0.9rem'}}/> : <span>{comm.comentario} - <small><i> {comm.user} {moment(comm.date).format('DD-MM-YYYY HH:mm')}</i></small>  {comm.edited? <b><small> &nbsp;[*COMENTARIO EDITADO*]</small> </b> : false}</span>}</span>
                                    {
                                        comm.id_user === state?.localAccountId?
                                        comentarioEnEdicion === comm.id_comentario?
                                        <span style={{display:'flex',justifyContent:'space-around',alignItems:'center',padding:'0.25rem',border:'1px solid lightgray',borderRadius:'5px',width:75, minWidth:75}}>
                                            {
                                                loadingUpdateComentarios?
                                                <FiCommand className="loading-icon" style={{fontSize:15, color:'gray'}} />
                                                :
                                                <IoSaveOutline title="Actualizar" size={15} onClick={loadingUpdateComentarios? () => {} : () => handleSaveUpdatedComment()} style={loadingUpdateComentarios? {color:'gray'} : {cursor:'pointer',color:'gray'}} />
                                            }
                                            <AiOutlineClose title="Cancelar" size={15} onClick={loadingUpdateComentarios? () => {} : () => handleCancelEditMode()} style={loadingUpdateComentarios? {color:'gray'} : {cursor:'pointer',color:'gray'}} />
                                        </span>
                                        :
                                        <span style={{display:'flex',justifyContent:'space-around',alignItems:'center',padding:'0.25rem',border:'1px solid lightgray',borderRadius:'5px',width:75, minWidth:75}}>
                                            <BsPencil title="Editar" size={15} onClick={loadingComentarios? () => {} : () => handleEditComment(comm)} style={loadingComentarios? {color:'gray'} : {cursor:'pointer',color:'gray'}} />
                                            <BsTrash3 title="Eliminar" size={15} onClick={loadingComentarios? () => {} : () => handleDeleteComment(comm.id_comentario)} style={loadingComentarios? {color:'gray'} : {cursor:'pointer',color:'gray'}} />
                                        </span>
                                        :
                                        false
                                    }
                                </p>
                            )
                        })}
                    </div>
                </div>
            }
            
            
            return renderized_popup
        }
 
    }

    const handleAddComment = async() => {
        try {
            setLoadingComentarios(true)
            let body:any = {
                id_user: state?.localAccountId,
                id_scenario: id,
                comentario: newComment,
                id_celda: selectedCell,
                id_provider: selectedRow.id_proveedor
            }
            const res = await addComentario(body)
            if(res.status === 200) {
                const {code,message} = res.data
                if(code === 200) {
                    handleUpdateComments()
                    success(message)
                } else {
                    error("Error al añadir el comentario")
                    setLoadingComentarios(false)
                }
            }
        } catch(e:any) {
            catchResponse(e)
            setLoadingComentarios(false)
        }

    }

    

    const handleUpdateComments = async(deleted_id?:number,action?:string) => {
        try {
            const res = await getComentariosByScenarioID(id)
            if(res.status === 200) {
                const {code,data} = res.data
                if(code === 200) {
                    let data_copy:any;
                    if(deleted_id && action) {
                        data_copy = dataTable.map((d:any) => {
                            if(`comment_${selectedCell}` in d) {
                                d[`comment_${selectedCell}`] = d[`comment_${selectedCell}`].filter((com:any) => com.id_comentario !== deleted_id)
                                if(d[`comment_${selectedCell}`].length === 0) delete d[`comment_${selectedCell}`]
                            }
                            
                            return d
                        })
                    } else {
                        data_copy = dataTable
                    }
                    
                    
                    data.map((comentario:any) => {
                        
                        let fila = data_copy.find((dc:any) => comentario.id_provider === dc.id_proveedor)
                        if(`comment_${comentario.id_celda}` in fila) {
                            let ids_comentarios = fila[`comment_${comentario.id_celda}`].map((c:any) => c.id_comentario)
                            if(!ids_comentarios.includes(comentario.id_comentario)) fila[`comment_${comentario.id_celda}`].push(comentario)
                        } else {
                            fila[`comment_${comentario.id_celda}`] = [comentario]
                        }
                    })

                    setData(data_copy)

                    let new_obj:any = Object.fromEntries(
                        Object.entries(selectedRow).filter(([key]) => !key.startsWith('comment_'))
                    );

                    let segundo:any = data_copy.find((dc:any) => selectedRow.id_proveedor === dc.id_proveedor)
                    for (const [key, value] of Object.entries(segundo)) {
                        if (key.startsWith('comment_')) {
                            new_obj[key] = value;
                        }
                    }
                    setSelectedRow(new_obj)
                    
                    //setSelectedRow(data_copy.find((dc:any) => selectedRow.id_proveedor === dc.id_proveedor))
                    handleCancelEditMode()
                    setFlag(!flag)
                    setNewComment("")
                    setLoadingComentarios(false)
                    setLoadingUpdateComentarios(false)
                } else {
                    setLoadingComentarios(false)
                    setLoadingUpdateComentarios(false)
                }
            }
        } catch(err:any) {
            catchResponse(err)
            setLoadingComentarios(false)
            setLoadingUpdateComentarios(false)
        }
    }

    const handlePressEnter = (e:any) => {
        if(newComment !== "") {
            if (e.key === 'Enter') {
                handleAddComment();
            }
        }  
    }

    return (
        <div className="card flex justify-content-center">
            <Dialog className={"edit-modal-dialog-base"} header={header} visible={visible} style={comm? { width: '25vw',height:'35vh' } :{ width: '45vw',height:'80vh' }} footer={footer} onHide={handleClose}>
                <div style={{minHeight:85,display:'flex',justifyContent:'center',alignItems:'center',padding:'1rem'}}>
                    <div className="card flex justify-content-center" style={{width:'95%'}}>
                        <label style={{fontFamily: 'var(--roboto-heavy)'}} htmlFor={"error-name"}>{renderLabel()}</label>
                        <div className="permisos__header-input">
                            <InputNumber  id={"error-name"} minFractionDigits={2} style={{width:'100%'}} className="scenario-inputs" onChange={handleChangeValue} disabled={justComment}   value={comm? selectedRow?.[selectedCell] : selectedRow?.[selectedCell][0] ?? 0 }    />

                            <span className="p-inputgroup-addon" >
                                <HiOutlinePencilSquare style={{fontSize:20}} />
                            </span>
                        </div>
                    </div>
                </div>
                {
                    comm?
                        false 
                    :

                        <div style={{display:'flex',border:'1px solid lightgray',borderRadius:'5pxx', height:'70%',justifyContent:'center',alignItems:'center',flexDirection:'column'}}>
                            <div style={loadingComentarios? {height:'80%',width:'90%',opacity:'0.5'} : {height:'80%',width:'90%'}}>
                                {renderedChat}

                            </div>
                            <div style={{height:'20%',width:'90%'}}>
                                <div className="card flex flex-wrap justify-content-center gap-3">
                                    <span className="p-input-icon-right" style={{width:'100%'}}>
                                        {
                                            loadingComentarios?
                                            <FiCommand className="loading-icon" style={{fontSize:20}} />
                                            :
                                            <i className="pi pi-send" onClick={newComment === "" || loadingUpdateComentarios || comentarioEnEdicion !== undefined? () => {} : () => handleAddComment()} style={{cursor:'pointer'}}  />
                                        }
                                        
                                        <InputText disabled={loadingComentarios || loadingUpdateComentarios || comentarioEnEdicion !== undefined} value={newComment} onChange={(e:any) => setNewComment(e.target.value)} onKeyPress={handlePressEnter} placeholder="Escribe un nuevo comentario..." style={{width:'100%',fontSize:'0.9rem'}}/>
                                    </span>

                                
                                </div>
                            </div>
                            
                        </div>
                }
            </Dialog>
        </div>
    )
}